export const numberToLocaleString = (
  num?: string | number,
  minFractionDigits = 2,
  maxFractionDigits = 2,
) => {
  if (num == null) {
    return '-';
  }

  return (+num).toLocaleString('hr-HR', {
    minimumFractionDigits: minFractionDigits,
    maximumFractionDigits: maxFractionDigits,
  });
};

export const parseToCurrencyString = (num: string) => {
  let rawNum = BigInt(num?.toString().replace(/\D+/g, '') || 0).toString();

  if (rawNum.length < 3) {
    rawNum = [...Array(3 - rawNum.length)].map((_) => '0').join('') + rawNum;
  }

  const decimalPosition = rawNum.toString().length - 2;
  const ret1 = [
    rawNum.slice(0, decimalPosition),
    rawNum.slice(decimalPosition),
  ].join('.');

  return numberToLocaleString(ret1);
};

export const parseFromCurrencyString = (price?: string) =>
  price?.replaceAll('.', '').replace(',', '.') || '0';

export const isDecimalNumber = (num: number) => num % 1 !== 0;

export const parseToInteger = (num: string) => {
  if (num) {
    const rawNum = (num?.toString().replace(/\D+/g, '') || 0).toString();
    return parseInt(rawNum, 10);
  }

  return '';
};
